<script setup lang="ts">
import { computed } from 'vue';
import type RobFlowVariables from '@/models/RobFlow';
import formatDate from '@/helpers/DateFormatterHelper';
import gettext from '@/i18n/gettext';

const { $gettext } = gettext;

const props = defineProps<{
  isOpen: boolean;
  robflowVariables: RobFlowVariables | null;
}>();
const emit = defineEmits(['update:isOpen']);

const cancel = () => {
  emit('update:isOpen', false);
};

const headers = [
  { title: $gettext('Variable'), value: 'key', sortable: true },
  { title: $gettext('Value'), value: 'value', sortable: true },
];

const tableData = computed(() => {
  if (!props.robflowVariables) {
    return [];
  }
  return Object.entries(props.robflowVariables.variables).map(
    ([key, value]) => ({
      key,
      value,
    }),
  );
});
</script>

<template>
  <v-dialog
    v-if="robflowVariables"
    :model-value="isOpen"
    max-width="600"
    @click:outside="cancel"
  >
    <v-card>
      <v-card-title>{{ $gettext('RobFlow Variables') }}</v-card-title>
      <v-card-text>
        <div>
          <p>
            {{ $gettext('Last update') }}:
            {{ formatDate(robflowVariables.timestamp * 1000, true) }}
          </p>
          <v-data-table
            class="my-4"
            :headers="headers"
            :items="tableData"
            density="compact"
          >
          </v-data-table>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" @click="cancel">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style lang="scss" scoped>
.v-overlay-container {
  .v-overlay--active {
    z-index: 2051 !important;
  }
}
</style>
